import {ImageUploadComponent} from "./ImageUploadComponent";

export const ImageUploadView = () => {
  return(
    <ImageUploadComponent />
  );
}
